// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import 'vuetify/dist/vuetify.min.css'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import myUpload from 'vue-image-crop-upload'
import VueMoment from 'vue-moment'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import axios from 'axios'
import config from './config'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import lodash from 'lodash'
import VueCroppie from 'vue-croppie'
import 'moment/locale/pt-br'
import FullCalendar from 'vue-full-calendar'
// import FirebaseStore from './plugins/firebase-store'
import firebase from 'firebase'

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

window.moment = require('moment')
let moment = window.moment
Vue.use(require('vue-full-calendar'))
Vue.use(require('vue-moment'))
moment.locale('pt-br')
Vue.use(VueMoment, {
  moment
})
Vue.use(FullCalendar)
Vue.use(Vuetify)
Vue.use(VueCroppie)

// formularios
Vue.use(VeeValidate)
Vue.use(VueTheMask)

// verificar se está sendo usado
Vue.use(myUpload)

axios.defaults.baseURL = config.serverURI

Vue.config.productionTip = false

var newAxios = axios.create({
  baseURL: config.serverURI
})

Vue.use(VueRouter)
Vue.use(VueAxios, newAxios)

// Vue.use(FirebaseStore)

Raven.config('https://57faa55d439a48e894fd5fad4bd56a2c@sentry.io/191236')
  .addPlugin(RavenVue, Vue)
  .install()
Vue.prototype.$raven = Raven

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // window.console.log('Transition', transition)
  if (to.meta.auth && (store.state.token === null)) {
    window.console.log('Not authenticated')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

var firebaseconfig = config.firebaseconfig
firebase.initializeApp(firebaseconfig)
Vue.prototype.fbauth = firebase.auth()
Vue.prototype.fbauth.signInAnonymously()
Vue.prototype.fbstorage = firebase.storage().ref()

/* eslint-disable no-new */
window.myApp = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(require('./App').default)
})



// WEBPACK FOOTER //
// ./src/main.js